var _defs, _path, _polygon, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeoLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 379.4 98.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 { fill: #ffffff; }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.81,76.42L35.5,5.04c-2.84-3.35-6.7-5.04-11.49-5.04h-10.8C4.56,0,0,4.37,0,12.63v85.87h22.35V22.22l68.31,71.1c2.65,3.44,6.51,5.18,11.49,5.18h10.8c8.64,0,13.2-4.42,13.2-12.78V0h-22.35v76.42h.01Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "161.49 56.39 218.94 56.39 218.94 39.41 137.49 39.41 137.49 98.5 250.3 98.5 250.3 79.56 161.49 79.56 161.49 56.39"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 137.49,
    width: 112.81,
    height: 19.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.25,0h-64.5c-18.02,0-27.15,8.35-27.15,24.81v48.88c0,16.46,9.14,24.81,27.15,24.81h64.5c18.02,0,27.15-8.35,27.15-24.81V24.81c0-16.46-9.13-24.81-27.15-24.81ZM354.65,28.27v41.96c0,6.14-2.92,8.88-9.45,8.88h-50.4c-6.54,0-9.45-2.74-9.45-8.88V28.27c0-6.24,2.91-9.03,9.45-9.03h50.4c6.54,0,9.45,2.78,9.45,9.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeoLogoWhite);
export default __webpack_public_path__ + "static/media/Neo_Logo_White.5ea850bd912b291b621a6c0d4eb5d047.svg";
export { ForwardRef as ReactComponent };